import {inject} from "@angular/core";
import { ActivatedRouteSnapshot, RedirectFunction, ResolveFn } from '@angular/router';
import {of} from "rxjs";
import { PlayerHost, PlayerMix, PlayerProgram } from '../models';
import {ContentSearcherService} from "./content-searcher.service";
import { StationManagerService } from './station-manager.service';
import { Uuid } from '@hidat/huijs-common';

/*****
 Resolver Functions to be used with the router
*****/

export const programRedirector: RedirectFunction = (
  route: Pick<
    ActivatedRouteSnapshot,
    | 'routeConfig'
    | 'url'
    | 'params'
    | 'queryParams'
    | 'fragment'
    | 'data'
    | 'outlet'
    | 'title'
  >
) => {
  const station = inject(StationManagerService);
  let programUid: Uuid | undefined;

  const pId = route.params['id'];
  if (pId) {
    // Let's see if we can find the program
    for (const program of station.programs) {
      if ((program.urlStub && program.urlStub === pId) || (program.uid === pId)) {
        programUid = program.uid;
      }
    }
  }
  if (programUid) {
    return '/library/shows/' + programUid;
  }
  return '/library/shows';
};

export const programResolver: ResolveFn<PlayerProgram | null> = ( route: ActivatedRouteSnapshot /*state: RouterStateSnapshot*/) => {
  const contentSearcher= inject(ContentSearcherService);
  const id = route.paramMap.get('id');
  if (id) {
    return contentSearcher.fetchProgram(id);
  }
  return of(null);
}

export const hostResolver: ResolveFn<PlayerHost | null> = ( route: ActivatedRouteSnapshot /*state: RouterStateSnapshot*/) => {
  const contentSearcher= inject(ContentSearcherService);
  const id = route.paramMap.get('id');
  if (id) {
    return contentSearcher.fetchHost(id);
  }
  return of(null);
}

export const mixResolver: ResolveFn<PlayerMix | null> = ( route: ActivatedRouteSnapshot) => {
  const contentSearcher= inject(ContentSearcherService);
  const id = route.paramMap.get('id');
  if (id) {
    return contentSearcher.fetchMix(id, "program,source,host,related_content");
  }
  return of(null);
}

export const mixOnlyResolver: ResolveFn<PlayerMix | null> = ( route: ActivatedRouteSnapshot) => {
  const contentSearcher= inject(ContentSearcherService);
  const id = route.paramMap.get('id');
  if (id) {
    return contentSearcher.fetchMix(id, "");
  }
  return of(null);
}
